import type { FaireProductEntity } from "../../entity_types/product";

export const p_g98867ktgy: FaireProductEntity = {
  token: "p_g98867ktgy",
  type: "product",
  name: "LAVENDER ROLLER | peaceful sleep aid and calming massage rol",
  brandName: "Visions Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/e2d7c2da1327a141a8e4125ff3fffd7287d5058c83d14ee2de45f10a80f92fce.jpeg",
  priceDollars: 5.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/3b6d42113786ac2c4ec74376970a7e675ea4513da92487e19f2801eb78608324.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
